import type { SearchContext } from '@shared/types/types.ts';
import { ASSORTMENTS_WITH_SPECIAL_TILE_DISPLAY_SET } from '@tilelist/domain/feature-visibility/AssortmentVisibility.ts';

function normalizeAssortment(searchContext: SearchContext | undefined): string | undefined {
    const assortment = searchContext?.assortment;
    return assortment ? assortment.toLowerCase() : undefined;
}

export function shouldShowShortTitle(searchContext?: SearchContext): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return true;

    return !ASSORTMENTS_WITH_SPECIAL_TILE_DISPLAY_SET.has(normalized);
}
